// import Chip from '@mui/material/Chip'
import { Badge, Chip, Tooltip, Zoom } from '@mui/material';
import React from 'react';

interface TypeProps {
  code: string
  name: string
}

const CurrencyCodeChip = (props: TypeProps) => {
  let variant: 'outlined' | undefined
  let color: 'primary' | 'warning' | 'error' | 'secondary' | 'success' | undefined

  if (props.code === 'ZAR') {
    color = 'success'
    variant = 'outlined'
  } else if (props.code === 'USD') {
    color = 'secondary'
    variant = 'outlined'
  } else if (props.code === 'EUR') {
    color = 'warning'
    variant = 'outlined'
  } else if (props.code === 'GBP') {
    color = 'warning'
    variant = 'outlined'
  } else if (props.code === 'XBT' || props.code === 'BTC') {
    color = 'primary'
    variant = 'outlined'
  }

  return (
  <Tooltip title={props.name} TransitionComponent={Zoom} arrow placement='bottom'>
    <Chip label={props.code} variant={variant} color={color} />
  </Tooltip>
  )
}

export default CurrencyCodeChip;
